<template>
    <div class="property-request-index">
        <create-dialog :value="dialog"
            @close-dialog="dialog=false, item=null"
            :item="item" @fetchData="fetchData" @setSelect="setSelect"></create-dialog>

        <v-card class="rounded-xl elevation-3 overflow-hidden">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Danh sách phiếu yêu cầu tài sản
                <v-spacer></v-spacer>
                
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData()" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                        <v-icon color="green darken-4">mdi-refresh</v-icon>
                    </v-btn>
                </div>
                
                <v-divider vertical class="mx-4"></v-divider>

                <!-- <export-excel :items ="items" :headers="headers" class="mx-2"></export-excel> -->

                <v-btn @click="dialog=true" dark color="teal darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> 
                    <v-icon left>mdi-plus</v-icon> THÊM PHIẾU
                </v-btn>
            </v-card-title>

            <v-sheet class="grey lighten-4 py-6">
                <v-row class="mx-n2 px-4" align="center">
                    <v-col cols="12" md="2" class="py-1">
                        <v-dialog ref="monthDialog" :return-value.sync="month" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="month" label="Tháng" prepend-inner-icon="mdi-calendar" readonly outlined dense hide-details
                                    v-bind="attrs" v-on="on" background-color="white" class="rounded-lg"></v-text-field>
                            </template>
                            <v-date-picker dense locale="vi" v-model="month" type="month" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="$refs.monthDialog.save(month)">Chọn</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" md="2" class="py-1">
                        <v-text-field v-model="filterCode" hide-details outlined dense placeholder="Nhập mã phiếu..." label="Mã phiếu"
                            prepend-inner-icon="mdi-identifier" background-color="white" class="rounded-lg"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="py-1">
                        <v-select v-model="filterStatus" hide-details outlined dense :items="['Mới', 'Đã nhận', 'Hoàn thành', 'Chối từ']" clearable
                            label="Trạng thái" prepend-inner-icon="mdi-filter-variant" background-color="white" class="rounded-lg"></v-select>
                    </v-col>
                    <v-col cols="12" md="3" class="py-1">
                        <v-text-field v-model="filterDepartment" hide-details outlined dense placeholder="Nhập tên chi nhánh..." label="Chi nhánh/Phòng ban"
                            prepend-inner-icon="mdi-office-building" background-color="white" class="rounded-lg"></v-text-field>
                    </v-col>
                </v-row>
            </v-sheet>

            <v-data-table :items="items" :headers="headers" height="calc(100vh - 320px)" :search="search"
                fixed-header class="elevation-0" :footer-props="{'items-per-page-options': [15, 30, 50, -1]}">
                
                <template v-slot:[`item.code`]="{ item }">
                    <span class="font-weight-bold blue-grey--text text--darken-3">{{ item.code }}</span>
                </template>

                <template v-slot:[`item.departmentName`]="{ item }">
                    <div class="subtitle-2 font-weight-medium" style="line-height: 1.2;">{{ item.departmentName }}</div>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="formatStatusColor(item.status)" small dark class="font-weight-bold" style="min-width: 90px; justify-content: center;">
                        {{ item.status }}
                    </v-chip>
                </template>

                <template v-slot:[`item.createdByName`]="{ item }">
                    <div class="d-flex align-center">
                        <v-avatar size="24" color="teal lighten-4" class="mr-2">
                            <v-icon x-small color="teal darken-3">mdi-account</v-icon>
                        </v-avatar>
                        <span class="caption font-weight-medium">{{ item.createdByName }}</span>
                    </div>
                </template>

                <template v-slot:[`item.receivedByName`]="{ item }">
                    <div class="d-flex align-center" v-if="item.receivedByName">
                        <v-avatar size="24" color="blue lighten-4" class="mr-2">
                            <v-icon x-small color="blue darken-3">mdi-account-check</v-icon>
                        </v-avatar>
                        <span class="caption">{{ item.receivedByName }}</span>
                    </div>
                    <span v-else class="caption silver--text">--</span>
                </template>

                <template v-slot:[`item.createdAt`]="{ item }">
                    <div class="caption grey--text text--darken-1">
                        <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                        {{ formatDateTime(item.createdAt) }}
                    </div>
                </template>

                <template v-slot:[`item.receivedAt`]="{ item }">
                    <div class="caption grey--text text--darken-1" v-if="item.receivedAt">
                        <v-icon x-small class="mr-1">mdi-clock-check-outline</v-icon>
                        {{ formatDateTime(item.receivedAt) }}
                    </div>
                    <span v-else class="caption grey--text text--lighten-1 italic">Chưa tiếp nhận</span>
                </template>

                <template v-slot:[`item.actions`]="{item}" >
                    <div class="d-flex flex-wrap py-2">
                        <v-btn x-small depressed rounded color="teal lighten-5" class="mx-1 my-1 teal--text text--darken-3 font-weight-bold" @click="edit(item)">
                            <v-icon left small>mdi-eye</v-icon> Chi tiết
                        </v-btn>
                        <v-btn x-small depressed rounded color="red lighten-5" class="mx-1 my-1 red--text text--darken-3 font-weight-bold" @click="deleteItem(item)">
                            <v-icon left small>mdi-delete</v-icon> Xóa
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="450px">
            <v-card class="rounded-lg">
                <v-card-title class="headline grey lighten-5 pb-4">
                    <v-icon color="warning" class="mr-3">mdi-alert-circle</v-icon>
                    Xác nhận xóa
                </v-card-title>
                <v-card-text class="pt-6 text-center subtitle-1">
                    Bạn có chắc muốn xoá phiếu <b class="error--text">{{ targetItem ? targetItem.code : '' }}</b> này không?
                    <div class="mt-2 caption grey--text">Hành động này không thể hoàn tác.</div>
                </v-card-text>
                <v-card-actions class="pb-4 px-6">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="rounded-pill px-4" @click="dialogDelete=false">Hủy bỏ</v-btn>
                    <v-btn color="error" class="rounded-pill px-6 elevation-2" @click="cfmDeleteItem">Xác nhận xóa</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CreateDialog from './Create.vue';
import http from '@/components/services/http-common';
import moment from 'moment/moment';

export default {
    components:{
        "create-dialog": CreateDialog,
    },
    watch:{
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        month(val)
        {
            this.fetchData();
        }
    },
    data () {
        return {
            month: moment().startOf("months").format("yyyy-MM"),
            item: null,
            items:[],
            search:"",

            filterCode:"", 
            filterStatus:"", 
            filterDepartment:"", 
            headers: [
                { text: 'Thao tác', value: 'actions', width: '8rem', align: 'center', sortable: false },
                { text: 'Mã phiếu', value: 'code', width: '10rem', 
                    filter: value => {
                        if (!this.filterCode) return true
                        return value.toUpperCase().includes(this.filterCode.toUpperCase())
                    },
                },
                { text: 'Chi nhánh / Phòng ban', value: 'departmentName', width: '15rem', 
                    filter: value => {
                        if (!this.filterDepartment) return true
                        return value.toUpperCase().includes(this.filterDepartment.toUpperCase())
                    },
                },
                { text: 'Trạng thái', value: 'status', width: '10rem', align: 'center',
                    filter: value => {
                        if (!this.filterStatus) return true
                        return value.toUpperCase().includes(this.filterStatus.toUpperCase())
                    },
                },
                { text: 'Người tạo', value: 'createdByName', width: '15rem' },
                { text: 'Ngày tạo', value: 'createdAt', width: '12rem' },
                { text: 'Người tiếp nhận', value: 'receivedByName', width: '15rem' },
                { text: 'Ngày tiếp nhận', value: 'receivedAt', width: '12rem' },
            ],

            dialogDelete: false,
            targetItem: null,
            dialog: false,
        }
    },
    methods: {
        formatStatusColor(status) {
            switch (status) {
                case 'Mới': return 'blue lighten-1';
                case 'Đã nhận': return 'orange lighten-1';
                case 'Hoàn thành': return 'success';
                case 'Chối từ': return 'error';
                default: return 'blue-grey lighten-1';
            }
        },
        formatDateTime(value) {
            if (!value) return '';
            return moment(value).format('DD/MM/YYYY HH:mm');
        },
        fetchData(id) {
            return http.get("propertyRequests", {
                params: {
                    month: this.month
                }
            }).then(res => {
                this.items = res.data.data;
                if(id){
                    let findData = this.items.find(x=>x.code==id)
                    console.log(findData)
                    this.item =findData
                    this.dialog = true;
                    // this.edit(findData)
                }
            })
        },
        setSelect(e)
        {
            this.item= {code : e};
        },
        
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            let url = `propertyRequests/${this.targetItem.code}`;
            return http.delete(url).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                switch (err.response.status)
                {
                    case 403:{
                        this.unauthorizeAlert();
                        this.dialogDelete = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },
    },
    mounted () {
        this.fetchData();
    }
}
</script>